import React from 'react';
import { Box, CircularProgress, Typography, Paper } from '@mui/material'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import moment from 'moment'

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

const AddSuperUser = ({ handleOptions, open, setOpen, loading, setOptions, options, setSelected }) => {


    const setUserState = (value) => {
        // if value === null, means the x in search tab is clicked, set the selected user state to null
        if (!value) {
            setSelected('')
            return
        }
        setOpen(false)
        setSelected(value)
    }

    return (
        <div className="search-autocomplete">
            <Autocomplete
                onChange={(e, value) => setUserState(value)}
                sx={{
                    width: { xs: 280, md: 375 },
                    mb: '30px',
                }}
                PaperComponent={({ children }) => (
                    <Paper sx={{
                        fontFamily: 'Josefin Sans',

                        "& .MuiAutocomplete-listbox": {
                            fontSize: { xs: '16px', md: '18px' },
                            "& li": {
                                borderBottom: "2px solid #D9D9D9",
                                letterSpacing: '.45px'
                            }
                        }
                    }}>
                        {children}
                    </Paper>
                )}
                open={open}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.first_name + ' ' + option.last_name + ' ' + option.email_address}
                options={options}
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        sx={{
                            "& .MuiInputLabel-root": { color: '#9FAE95' },//styles the label
                            "& .MuiOutlinedInput-root": {
                                "& > fieldset": { borderColor: "#9FAE95" },
                                borderRadius: '50px',
                                height: '50px',
                                paddingLeft: '20px !important',
                            },
                            "& .MuiOutlinedInput-root.Mui-focused": {
                                "& > fieldset": {
                                    borderColor: "#9FAE95"
                                },
                            },

                            bgcolor: '#fff',
                            borderRadius: 1,
                        }}
                        size="small"
                        label=""
                        variant='outlined'
                        placeholder='Search...'
                        onChange={(e) => handleOptions(e.target.value)}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                            startAdornment: (
                                <SearchIcon />
                            ),
                        }}
                    />
                )}

                renderOption={(props, option) => {
                    return (
                        <li {...props} key={option.id}>
                            <Box
                                sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}
                            >
                                <Typography variant="body1" color="initial" className="indi-font-family"> {option?.first_name} {option.last_name}</Typography>
                                <Typography variant="body1" color="initial" className="indi-font-family"> {option?.email_address}</Typography>
                                <Typography variant="body1" color="initial" className="indi-font-family"> {option?.name}</Typography>
                                {
                                    option?.dob && <Typography variant="body1" color="initial" className="indi-font-family"> {moment(option?.dob).format('MMM-DD-YYYY')}</Typography>
                                }
                            </Box>
                        </li>
                    );
                }}
            />
        </div>
    );
};

export default AddSuperUser;